import React from 'react';
//@ts-ignore
import { nanoid } from 'nanoid/non-secure';
var BatchImportIcon = function BatchImportIcon() {
  var id = nanoid();
  var linearGradientId = "paint0_linear_".concat(id);
  var clipPathId = "clip0_".concat(id);
  return /*#__PURE__*/React.createElement("svg", {
    width: "26",
    height: "26",
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "25.6",
    height: "25.6",
    rx: "4",
    fill: "#FFF7E8"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(clipPathId, ")")
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74284 12.4604H11.1714V16.8218H14.8286V12.4604H18.2571C18.284 12.4604 18.3102 12.4564 18.3364 12.4525C18.3423 12.4516 18.3482 12.4507 18.3541 12.4499C18.3906 12.4444 18.418 12.4371 18.4455 12.4288C18.4674 12.4224 18.4894 12.416 18.5113 12.4069C18.5168 12.4046 18.5223 12.4019 18.5278 12.3991C18.5333 12.3964 18.5387 12.3936 18.5442 12.3914C18.5511 12.3881 18.558 12.385 18.565 12.3819C18.5801 12.3752 18.5953 12.3685 18.6101 12.3594C18.7819 12.2524 18.8907 12.0746 18.9269 11.8798C18.936 11.8245 18.9397 11.7884 18.9406 11.7518C18.9406 11.7472 18.9411 11.7429 18.9417 11.7386C18.9423 11.7342 18.9429 11.7299 18.9429 11.7253C18.9429 11.7166 18.9418 11.7081 18.9407 11.6996C18.9399 11.6935 18.9391 11.6873 18.9387 11.681C18.9384 11.6772 18.9381 11.6735 18.9378 11.6698C18.9369 11.6573 18.9359 11.6452 18.9342 11.6325C18.9191 11.504 18.8738 11.3861 18.8048 11.2874L13.6583 5.14107C13.5211 4.88644 13.2546 4.64644 13 4.69535C12.7454 4.64644 12.4784 4.88644 12.3422 5.14107L7.19519 11.2874C7.12435 11.39 7.07992 11.5086 7.06581 11.6325C7.06405 11.6452 7.0631 11.6573 7.06213 11.6698C7.06185 11.6735 7.06156 11.6772 7.06124 11.681C7.06086 11.6873 7.06007 11.6935 7.05929 11.6996C7.05821 11.7081 7.05713 11.7166 7.05713 11.7253C7.05713 11.7299 7.0577 11.7342 7.05827 11.7386C7.05884 11.7429 7.05941 11.7472 7.05941 11.7518C7.06032 11.7883 7.06383 11.8246 7.06993 11.8606C7.10924 12.0746 7.21804 12.2524 7.38993 12.3589C7.40591 12.3691 7.42239 12.3763 7.43882 12.3834C7.44448 12.3859 7.45013 12.3883 7.45576 12.3909C7.4585 12.3923 7.46125 12.3937 7.46399 12.3951C7.47222 12.3993 7.48045 12.4035 7.48867 12.4069C7.51022 12.4153 7.5322 12.4227 7.5545 12.4288C7.5818 12.4374 7.60958 12.4442 7.6377 12.4494C7.6448 12.4504 7.65164 12.4514 7.65825 12.4523C7.68912 12.4567 7.71536 12.4604 7.74284 12.4604ZM14.8286 18.2884H11.1714V20.854C11.1714 20.9753 11.2196 21.0916 11.3053 21.1773C11.391 21.263 11.5073 21.3112 11.6286 21.3112H14.3714C14.4927 21.3112 14.6089 21.263 14.6947 21.1773C14.7804 21.0916 14.8286 20.9753 14.8286 20.854V18.2884Z",
    fill: "url(#".concat(linearGradientId, ")")
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: linearGradientId,
    x1: "13",
    y1: "4.68896",
    x2: "13",
    y2: "21.3112",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB65D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#FF7D00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: clipPathId
  }, /*#__PURE__*/React.createElement("rect", {
    width: "17.6",
    height: "17.6",
    fill: "white",
    transform: "translate(4 4)"
  }))));
};
export default BatchImportIcon;